import React, { useState, useMemo, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEraser, faPlus } from '@fortawesome/free-solid-svg-icons'

import MapTableInterface from '../forms/MapTableInterface.js';
import DatePicker from "react-datepicker";
import InputWrapper from '../forms/InputWrapper.js';
// import NumericInput from 'react-numeric-input';
import { callback } from '../../helpers.js';

import api from '../../api/index.js';

import Row from './row.js';

export default (props) => {

	const [recordId, setRecordId] = useState(props.recordId || false);
	const [date, setDate] = useState(props.date);
	const [invoice, setInvoice] = useState(props.invoice || '');
	const [processor, setProcessor] = useState(props.processor);
	const [grade, setGrade] = useState(props.grade);
	const [quotedPrice, setQuotedPrice] = useState(props.quotedPrice || '');
	const [saveDisabled, setSaveDisabled] = useState(false);

	const rowbase = {'field': false, weight: 0};
	const [rows, setRows] = useState(props.rows);

	// ... Some thing to add fields to it
	useMemo(()=>{
		console.log("Resetting state", props);
		setRecordId(props.recordId || false);
		setDate(props.date || false);
		setInvoice(props.invoice || '');
		setProcessor(props.processor || false);
		setGrade(props.grade || false);
		if (props.rows)
			setRows(props.rows)
		else
			setRows([Object.assign(rowbase)]);
	}, [props.recordId]);
	
	
	
	
	const rowChange = (i, e) => {
		console.log(i, e);
		let r = JSON.parse(JSON.stringify(rows))
		switch(e.target.name) {
			case 'field':
				r[i]['field'] = e.target.value;
				break;
			case 'weight':
				r[i]['weight'] = e.target.value;
				break;
		}
		setRows(r);
	}
	
	const more = (e) => {
		e.preventDefault();
		setRows(rows.concat(rowbase));
	}
	
	

	const save = async (e) => {
		setSaveDisabled('disabled');
		e.preventDefault();
		// Package the info for saving
		let payload = {
			date: date.api(),
			invoiceNumber: invoice,
			processor: processor,
			grade: grade,
			quotedPrice: quotedPrice,
			fields: rows
		}
		
		console.log("Saving", payload);
		
		try {
			let response = false;
			console.log(recordId);
			if (recordId == false || typeof recordId === 'undefined') {
				payload['fields'] = JSON.stringify(payload['fields']);
				response = await api.post('harvests', payload);
				callback(props.onAdded, [response]);
			} else {
				response = await api.put('harvests/' + recordId, payload);
				callback(props.onSaved, [response]);
			}
		} catch(e) {
			api.handleExceptions(e);
			setSaveDisabled(false);
		};
	}
	
	console.log(rows);
	let o = [];
	if (rows) {
		for(let i=0; i < rows.length; i++){
			console.log("weight", rows[i]['weight']);
			o.push(<Row key={i} date={date} field={rows[i]['field']} weight={rows[i]['weight']} onChange={rowChange.bind(this,i)}/>);
		}
	}
	return <div className="harvest-form">
		<InputWrapper label="Date: "  info="The date of this harvest record.">
			<DatePicker
				id="date"
				selected={date}
				onChange={(e)=>setDate(e)}
			/>
			<button onClick={(e)=>setDate(null)} className="block plus" title="Clear the date"><FontAwesomeIcon icon={faEraser} className="eraserIcon" /></button>
		</InputWrapper>
		<InputWrapper label="Invoice Number: "  info="The invoice number associated with this harvest record.">
			<input type="text" className="invoice" name="invoice" value={invoice} onChange={(e)=>setInvoice(e.target.value)} />
		</InputWrapper>
		<InputWrapper label="Processor: "  info="The processor associated with this harvest record.">
		<MapTableInterface 
			maptable="processors" 
			value={processor} 
			name="processor" 
			onChange={(e)=>setProcessor(e.target.value.value)} 
		/>
		</InputWrapper>
		<InputWrapper label="Grade: "  info="The grade associated with this harvest record.">
		<MapTableInterface 
			maptable="grade" 
			value={grade} 
			name="grade" 
			onChange={(e)=>setGrade(e.target.value.value)} 
		/>
		</InputWrapper>
		<InputWrapper label="Quoted Price: "  info="The price the processor quoted you (optional).">
			<input type="text" className="quotedPrice" name="quotedPrice" value={quotedPrice} onChange={(e)=>setQuotedPrice(e.target.value)} />
		</InputWrapper>
		<h2>Records <button onClick={more} className="block plus" title="Add another record."><FontAwesomeIcon icon={faPlus}/></button></h2>
		{o}
		<button disabled={saveDisabled} className="block" onClick={save}>Save</button>
	</div>;
}